import { PregnancyDatingMethod } from "./PregnancyDatingMethodEnum";

class OntarioObstetricalPregnancySummary {
    public LastMenstrualPeriodDate: Date | null;
    public MenstrualCycleLength: number = 28;
    public IsLastMenstrualPeriodDateCertain: boolean | null;
    public IsMenstrualCycleRegular: boolean | null;
    public IsPregnancyPlanned: boolean | null;
    public ContraceptiveType: string;
    public LastUsedContraceptiveDate: Date | null;
    public IsAssistedConceptionUsed: boolean | null;
    public AssistedConceptionDetails: string;
    public EstimatedDateOfBirthByLastMenstrualPeriodDate: Date | null;
    public DatingMethodValue: PregnancyDatingMethod;
    public DatingMethodOtherComment: string;
    public IntrauterineInseminationProcedureDate: Date | null;
    public EmbryoTransferDate: Date | null;
    public NeonatalOrChildDeathCount: number | null;
    public IgnoreNumberOfDaysToEstimateDueDate: boolean | null;

    constructor(fields?: Partial<OntarioObstetricalPregnancySummary>) {
        Object.assign(this, fields);
    }
}

export { OntarioObstetricalPregnancySummary };
